'use client';

import Image from 'next/image';

import ArrowIcon from '@/fo/icons/base/icons/arrow.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './Banner.styles';

type BannerProps = {
  banner: {
    image: {
      sm: string;
      md: string;
    };
    alt: string;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    buttonText?: string;
    link?: string;
  };
};

export function Banner({ banner }: BannerProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <picture>
        <source
          srcSet={banner.image.sm}
          media="(max-width: 639px)"
        />
        <Image
          className={slots.image()}
          alt={banner.alt}
          src={banner.image.md}
          width={800}
          height={400}
        />
      </picture>
      <div className={slots.content()}>
        {banner.title}
        {banner.subtitle}
        {banner.buttonText && banner.link && (
          <UiKitButtonBase
            as="link"
            href={banner.link || '/'}
            color="white"
            className={slots.button()}
          >
            <div className={slots.buttonContent()}>
              {banner.buttonText}
              <ArrowIcon />
            </div>
          </UiKitButtonBase>
        )}
      </div>
    </div>
  );
}
